import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

/**
 * Public redirect for shortened links: /r/:code
 * Resolves via main API and sends the browser to the original URL.
 */
export default function ShortLinkRedirect() {
  const { code } = useParams<{ code: string }>();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const base =
          process.env.REACT_APP_MAIN_URL || "http://localhost:4999/api";
        const response = await fetch(
          `${base}/public/r/${encodeURIComponent(code)}/resolve`
        );
        if (!response.ok) {
          throw new Error("not found");
        }
        const data = await response.json();
        const url = data?.payload?.originalUrl;
        if (!url) throw new Error("missing url");
        if (!cancelled) {
          window.location.replace(url);
        }
      } catch (e) {
        if (!cancelled) setError("No se pudo abrir este enlace.");
      }
    };
    if (code) void run();
    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "system-ui, sans-serif",
        color: "#475569",
      }}
    >
      {error || "Redirigiendo…"}
    </div>
  );
}
